import EventEmitter from 'eventemitter2';
/**
 * 
 * Base class for Component-based object
 * 
 * @category components
 * @author Geoffrey Mayeux
 */
class Component extends EventEmitter{
	/**
	 * Create a Component
	 * @param  {HTMLDivElement} Dom element
	 */
	constructor(element){
		super();
		this.element = element;
	}
	/**
	 * Initializes a component.
	 */
	async init(){}

	/**
	 * Register events of this component
	 */
	async attach(){

	}

	/**
	 * Unregister events from this component
	 */
	async detach(){

	}

	/**
	 * Destroys the component
	 */
	async destroy(){

	}
}

export default Component;
export { Component };